import {
  BarChart3,
  Building2,
  Database,
  FileText,
  Library,
  Lightbulb,
  ShieldCheck,
  SlidersHorizontal,
  Trash2,
  Users,
} from "lucide-react";

export type AdminNavItem = {
  label: string;
  href: string;
  icon: React.ComponentType<{ className?: string }>;
};

export type AdminNavGroup = {
  label?: string;
  items: AdminNavItem[];
};

export const adminNavGroups: AdminNavGroup[] = [
  {
    items: [{ label: "Visao geral", href: "/", icon: BarChart3 }],
  },
  {
    label: "Plataforma",
    items: [
      { label: "Usuarios", href: "/usuarios", icon: Users },
      { label: "Organizações", href: "/organizacoes", icon: Building2 },
      { label: "Planos e features", href: "/planos-e-features", icon: SlidersHorizontal },
      { label: "Auditoria", href: "/auditoria", icon: FileText },
      { label: "Solicitações LGPD", href: "/lgpd", icon: ShieldCheck },
      { label: "Exclusões agendadas", href: "/exclusoes", icon: Trash2 },
    ],
  },
  {
    label: "Catálogo",
    items: [
      { label: "Base de mercado", href: "/base", icon: Library },
      { label: "Candidatos", href: "/base/candidatos", icon: Lightbulb },
    ],
  },
  {
    label: "Sistema",
    items: [
      { label: "Banco de dados", href: "/database", icon: Database },
    ],
  },
];
